/**
 * `/meetings/:id/transcript` — what was said, after everybody has gone.
 *
 * A page of its own rather than a tab in the room: the room is a live thing
 * with a microphone in it, and a meeting that ended last week is something
 * somebody reads. The room links here when it is over and this is what the link
 * opens.
 */

import { useT } from '../i18n';
import { useRouter } from '../router';
import { useStore } from '../lib/relay/store';
import { Empty, PanelHeader, useNarrow } from '../components/Shell';
import { TranscriptPanel } from '../components/meeting/TranscriptPanel';
import { ds } from '../ds';

export function TranscriptPage({ id }: { id: string }) {
  const { IconButton } = ds();
  const t = useT();
  const narrow = useNarrow();
  const { navigate } = useRouter();
  const meeting = useStore((s) => s.meetings().find((m) => m.id === id));

  if (!meeting) return <Empty title={t('app.notfound.title')} />;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <PanelHeader
        title={
          <span style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-8)' }}>
            {narrow && (
              <IconButton
                icon="ArrowLeft"
                label={t('chrome.back')}
                onClick={() => navigate('/meetings')}
              />
            )}
            {meeting.title}
          </span>
        }
        subtitle={t('call.transcript.title')}
      />
      <div className="mv-scroll mv-page" style={{ flex: 1, padding: 'var(--space-24)' }}>
        <div style={{ maxWidth: 720 }}>
          <TranscriptPanel meetingId={meeting.id} />
        </div>
      </div>
    </div>
  );
}
